import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../styles';

const InputField = ({onSearch, value, onChange}) => {
    const {t} = useTranslation();
    const [placeholder, setPlaceholder] = useState(t('search.placeholder'));

    const handleChange = e => {
        onChange(e.target.value);
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            e.target.blur();
            onSearch(e.target.value);
        }
    };

    const search = () => {
        onSearch(value);
    };

    const focus = () => {
        setPlaceholder('');
    };
    const blur = () => {
        setPlaceholder(t('search.placeholder'));
    };

    const clear = () => {
        onChange('');
    };

    return (
        <Container>
            <input
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onFocus={focus}
                onBlur={blur}
            />
            {value === '' && <SearchIcon onClick={search} />}
            {value !== '' && <ClearIcon onClick={clear} />}
        </Container>
    );
};

const Container = styled.div`
    height: 70px;
    width: calc(100% - 50px);
    border-radius: 10px;
    position: relative;
    transition: 0.3s all;
    flex-direction: row;
    display: flex;
    max-width: 812px;
    align-items: center;
    padding: 0px 16px;
    margin-bottom: 30px;

    background: linear-gradient(
            90deg,
            #ffd93f 0%,
            #ffd93f 4.79%,
            #00aeef 28.08%,
            #ffd93f 38.29%,
            #ffd93f 64.14%,
            #ec008c 86.86%,
            #ffd93f 96.35%
        )
        left bottom #777 no-repeat;

    background-size: 100% 4px;
    background-color: rgba(70, 54, 70, 1);
    &:hover {
        background-color: rgba(70, 54, 70, 0.8);
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
    }

    input {
        font-family: TTNormsProExtraBlack;
        font-style: normal;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-size: 30px;
        font-weight: 900;
        color: #fff;

        background-color: transparent;
        text-transform: uppercase;

        ::placeholder {
            color: white;
        }
    }

    ${mobileMediaQuery} {
        width: calc(100% - 40px);
    }
`;

const SearchIcon = styled.img.attrs({
    src: require('../../assets/ic_search2.png'),
})`
    width: 52px;
    height: 52px;
    cursor: pointer;
`;

const ClearIcon = styled.div`
    width: 52px;
    height: 52px;
    cursor: pointer;

    background-color: #fff;
    mask: url(${require('../../assets/close.svg')}) no-repeat center;
`;

export default InputField;
